import React from "react";
import {
  RefreshCw,
  CheckCircle,
  XCircle,
  StopCircle,
  Clock,
} from "lucide-react";
import "./AgentExecutionPanel.scss";

/**
 * Shows current agent execution status with visual indicator
 * Status types: RUNNING, COMPLETED, FAILED, STOPPED
 */
const AgentStatusIndicator = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case "RUNNING":
        return {
          Icon: RefreshCw,
          text: "Agent running...",
          className: "running",
          spinning: true,
        };
      case "COMPLETED":
        return {
          Icon: CheckCircle,
          text: "Completed",
          className: "completed",
          spinning: false,
        };
      case "FAILED":
        return {
          Icon: XCircle,
          text: "Failed",
          className: "failed",
          spinning: false,
        };
      case "STOPPED":
        return {
          Icon: StopCircle,
          text: "Stopped",
          className: "stopped",
          spinning: false,
        };
      default:
        return {
          Icon: Clock,
          text: "Ready",
          className: "idle",
          spinning: false,
        };
    }
  };

  const config = getStatusConfig();
  const { Icon } = config;

  return (
    <div className={`agent-status-indicator ${config.className}`}>
      <Icon className={`status-icon ${config.spinning ? "spinning" : ""}`} size={20} />
      <span className="status-text">{config.text}</span>
    </div>
  );
};

export default AgentStatusIndicator;
